export default __webpack_public_path__ + "static/media/covid19.37e581cb.png";